<div class="admin-container">
  <div class="admin-table-container">
    <h5 class="admin-title">Email Subscription</h5>
    <p class="admin-subhead">
      Please select the respective gateways and the respective feature based email notifications that you would like to
      subscribe/unsubscribe.
    </p>
    <p class="admin-subscribe-choices-text">
      The email notifications for system/trend alerts for below subscribed choices shall appear based on the schedule set by user in the
      notifications tab.
    </p>
    <div class="email-notification-table" *ngIf="!isLoading; else loader">
      <table
        mat-table
        *ngIf="dataSource && dataSource.data && dataSource.data.length > 0"
        matSort
        class="table mat-elevation-z8"
        [dataSource]="dataSource"
        matSortActive="timestamp"
        matSortDirection="desc">
        <ng-container matColumnDef="assetName" sticky>
          <th mat-header-cell class="table-header" *matHeaderCellDef>
            <span>
              <mat-checkbox
                class="checkbox"
                id="vi_assetName_table_checkbox"
                [(ngModel)]="siteCheckBox"
                (ngModelChange)="siteCheckBoxChange()">
              </mat-checkbox>
            </span>
            <span>Site name</span>
          </th>
          <td
            mat-cell
            class="emailsetting email-sticky-col-site"
            *matCellDef="let element; let i = index"
            id="{{ 'vi_email_assetName' + (i + 1) }}">
            <span>
              <mat-checkbox
                class="checkbox"
                id="{{ 'vi_matemail_assetName' + (i + 1) }}"
                [(ngModel)]="element.site"
                (ngModelChange)="enableBtn(); siteValueChange(element)">
              </mat-checkbox>
            </span>
            <span class="text-field">{{ element.assetName }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="gatewayName" sticky>
          <th mat-header-cell class="table-header" *matHeaderCellDef>Gateway name</th>
          <td
            mat-cell
            class="emailsetting email-sticky-col-gateway"
            *matCellDef="let element; let i = index"
            id="{{ 'vi_email_gatewayName' + (i + 1) }}">
            <span class="text-field">{{ element.gatewayName }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="events">
          <th mat-header-cell *matHeaderCellDef>Event</th>
          <td mat-cell *matCellDef="let element; let i = index" id="{{ 'vi_email_event' + (i + 1) }}">
            <mat-checkbox
              class="checkbox"
              id="{{ 'vi_matemail_event' + (i + 1) }}"
              [(ngModel)]="element.events"
              (ngModelChange)="enableBtn(); checkBoxChange(element)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="sendEmail">
          <th mat-header-cell class="table-header" *matHeaderCellDef>Send email</th>
          <td mat-cell *matCellDef="let element; let i = index" id="{{ 'vi_email_event_media' + (i + 1) }}">
            <mat-button-toggle-group
              disableRipple="true"
              id="vi_camera_profile_alerts_view_mode"
              [value]="element.emailWithMedia"
              (change)="selectionChange($event.value, element)"
              class="switch-btn">
              <mat-button-toggle value="with"> With media </mat-button-toggle>
              <mat-button-toggle value="without"> Without media </mat-button-toggle>
            </mat-button-toggle-group>
          </td>
        </ng-container>
        <ng-container matColumnDef="notification">
          <th mat-header-cell *matHeaderCellDef>Notification</th>
          <td mat-cell *matCellDef="let element; let i = index" id="{{ 'vi_email_notification' + (i + 1) }}">
            <mat-checkbox
              class="checkbox"
              id="{{ 'vi_matemail_notification' + (i + 1) }}"
              [(ngModel)]="element.notification"
              (ngModelChange)="enableBtn(); checkBoxChange(element)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="csvfile">
          <th mat-header-cell *matHeaderCellDef>Site Summary</th>
          <td mat-cell *matCellDef="let element; let i = index" id="{{ 'vi_email_csvfile' + (i + 1) }}">
            <mat-checkbox
              class="checkbox"
              id="{{ 'vi_email_csvfile' + (i + 1) }}"
              [(ngModel)]="element.csvfile"
              (ngModelChange)="enableBtn(); checkBoxChange(element)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="lastUpdated">
          <th mat-header-cell class="table-header" *matHeaderCellDef>Last updated at</th>
          <td mat-cell *matCellDef="let element; let i = index" id="{{ 'vi_admin_last_updated' + (i + 1) }}">
            <span class="text-field">{{ element.createdAt | date : 'medium' : currentZone }}</span>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row class="table-content" *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
  <div class="btn-details">
    <button type="submit" class="btn reset-btn" [disabled]="!isDirty" [color]="primary" (click)="resetSettings()" slb-secondary-button>
      Reset
    </button>
    <button type="submit" class="btn save-btn" [disabled]="disableSave" (click)="saveSettings()" slb-button>Save</button>
  </div>
</div>
<ng-template #loader>
  <div class="spinner">
    <app-spinner></app-spinner>
  </div>
</ng-template>
<slb-toast></slb-toast>
